import { render, staticRenderFns } from "./departmentfeepaydetail.vue?vue&type=template&id=49a44512&"
import script from "./departmentfeepaydetail.vue?vue&type=script&lang=js&"
export * from "./departmentfeepaydetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports